import PropTypes from 'prop-types';
import { Trash, Info } from 'lucide-react';
import BaseModal from '@/shared/components/modals/core/BaseModal.jsx';
import Button from '@/shared/components/elements/Button';

const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'حذف آیتم',
  itemName,
  description = 'این عملیات قابل بازگشت نیست و تمام اطلاعات مرتبط حذف خواهد شد.',
  isLoading = false,
}) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={<Trash size={24} />}
      iconVariant="danger"
      size="sm"
      closeOnBackdropClick={!isLoading}
      closeOnEscape={!isLoading}
      showCloseButton={!isLoading}
      footer={
        <>
          <Button
            type="button"
            variant="secondary"
            size="lg"
            fullWidth
            onClick={onClose}
            disabled={isLoading}
          >
            انصراف
          </Button>
          <Button
            type="button"
            variant="danger"
            size="lg"
            fullWidth
            onClick={onConfirm}
            loading={isLoading}
            disabled={isLoading}
            icon={<Trash size={18} />}
            iconPosition="left"
          >
            حذف
          </Button>
        </>
      }
    >
      <div className="space-y-4 p-4 sm:p-6">
        <p className="text-tertiary-80 text-sm leading-relaxed dark:text-gray-300">
          آیا از حذف{' '}
          <span className="text-primary-100 font-bold break-words dark:text-orange-500">
            {itemName}
          </span>{' '}
          اطمینان دارید؟
        </p>

        <div className="rounded-lg border border-red-200 bg-red-50 p-3 backdrop-blur-sm sm:rounded-xl sm:p-4 dark:border-red-500/30 dark:bg-red-500/10">
          <div className="flex items-start gap-2">
            <Info
              size={16}
              className="mt-0.5 flex-shrink-0 text-red-600 dark:text-red-400"
            />
            <p className="text-xs leading-relaxed text-red-700 dark:text-red-300">
              {description}
            </p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

DeleteConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  itemName: PropTypes.string.isRequired,
  description: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default DeleteConfirmModal;
